// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-images-page {
  min-height: 100vh;
  background: linear-gradient(to bottom, #f7fafc, #edf2f7);
  padding: 40px 20px;
}

.images-container {
  max-width: 1200px;
  margin: 0 auto;
}

.images-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 20px;
}

.images-header h1 {
  font-size: 2.5rem;
  font-weight: 900;
  color: #2d3748;
  margin: 0;
  animation: fadeInDown 0.6s ease;
}

.back-home-btn,
.home-btn {
  background: white;
  border: 2px solid #e2e8f0;
  padding: 12px 24px;
  border-radius: 25px;
  font-weight: 600;
  color: #4a5568;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.back-home-btn:hover,
.home-btn:hover {
  background: none;
  color: white;
  border-color: transparent;
  transform: translateY(-2px);
}

.order-info-card {
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  animation: fadeIn 0.8s ease;
}

.order-info-card h2 {
  font-size: 1.5rem;
  font-weight: 800;
  color: #2d3748;
  margin: 0 0 20px 0;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.info-label {
  font-size: 0.9rem;
  color: #718096;
  font-weight: 500;
}

.info-value {
  font-size: 1.1rem;
  color: #2d3748;
  font-weight: 700;
}

.download-section {
  text-align: center;
  margin-bottom: 40px;
  animation: fadeIn 1s ease;
}

.download-all-btn {
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: white;
  border: none;
  padding: 18px 40px;
  border-radius: 30px;
  font-size: 1.2rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(72, 187, 120, 0.3);
}

.download-all-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 25px rgba(72, 187, 120, 0.4);
}

.download-hint {
  margin-top: 15px;
  color: #718096;
  font-size: 0.95rem;
}

.images-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
  animation: fadeIn 1.2s ease;
}

.gallery-item {
  position: relative;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: white;
  cursor: pointer;
}

.gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.gallery-item img {
  width: 100%;
  height: 300px;
  object-fit: cover;
  display: block;
}

.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.gallery-item:hover .image-overlay {
  opacity: 1;
}

.download-btn {
  background: none;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.download-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 15px rgba(255, 140, 0, 0.4);
}

.image-number {
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
}

.footer-actions {
  text-align: center;
  padding: 40px 0;
}

.home-btn {
  font-size: 1.1rem;
  padding: 15px 35px;
}

.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  text-align: center;
  padding: 40px 20px;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 5px solid #e2e8f0;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-container p,
.error-container p {
  font-size: 1.2rem;
  color: #718096;
  margin: 10px 0;
}

.error-container h2 {
  font-size: 2rem;
  color: #2d3748;
  margin: 0 0 15px 0;
}

.no-images {
  grid-column: 1 / -1;
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.no-images p {
  font-size: 1.2rem;
  color: #718096;
  margin: 0;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .images-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .images-header h1 {
    font-size: 2rem;
  }

  .images-gallery {
    grid-template-columns: 1fr;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .download-all-btn {
    width: 100%;
    padding: 15px;
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrderImages.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,+BAA+B;AACjC;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,qDAAqD;EACrD,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,oEAAoE;EACpE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":[".order-images-page {\n  min-height: 100vh;\n  background: linear-gradient(to bottom, #f7fafc, #edf2f7);\n  padding: 40px 20px;\n}\n\n.images-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.images-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.images-header h1 {\n  font-size: 2.5rem;\n  font-weight: 900;\n  color: #2d3748;\n  margin: 0;\n  animation: fadeInDown 0.6s ease;\n}\n\n.back-home-btn,\n.home-btn {\n  background: white;\n  border: 2px solid #e2e8f0;\n  padding: 12px 24px;\n  border-radius: 25px;\n  font-weight: 600;\n  color: #4a5568;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1rem;\n}\n\n.back-home-btn:hover,\n.home-btn:hover {\n  background: none;\n  color: white;\n  border-color: transparent;\n  transform: translateY(-2px);\n}\n\n.order-info-card {\n  background: white;\n  border-radius: 20px;\n  padding: 30px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n  animation: fadeIn 0.8s ease;\n}\n\n.order-info-card h2 {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: #2d3748;\n  margin: 0 0 20px 0;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.info-label {\n  font-size: 0.9rem;\n  color: #718096;\n  font-weight: 500;\n}\n\n.info-value {\n  font-size: 1.1rem;\n  color: #2d3748;\n  font-weight: 700;\n}\n\n.download-section {\n  text-align: center;\n  margin-bottom: 40px;\n  animation: fadeIn 1s ease;\n}\n\n.download-all-btn {\n  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);\n  color: white;\n  border: none;\n  padding: 18px 40px;\n  border-radius: 30px;\n  font-size: 1.2rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(72, 187, 120, 0.3);\n}\n\n.download-all-btn:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 25px rgba(72, 187, 120, 0.4);\n}\n\n.download-hint {\n  margin-top: 15px;\n  color: #718096;\n  font-size: 0.95rem;\n}\n\n.images-gallery {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 25px;\n  margin-bottom: 40px;\n  animation: fadeIn 1.2s ease;\n}\n\n.gallery-item {\n  position: relative;\n  border-radius: 15px;\n  overflow: hidden;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  background: white;\n  cursor: pointer;\n}\n\n.gallery-item:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.gallery-item img {\n  width: 100%;\n  height: 300px;\n  object-fit: cover;\n  display: block;\n}\n\n.image-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.gallery-item:hover .image-overlay {\n  opacity: 1;\n}\n\n.download-btn {\n  background: none;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n}\n\n.download-btn:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 15px rgba(255, 140, 0, 0.4);\n}\n\n.image-number {\n  color: white;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.footer-actions {\n  text-align: center;\n  padding: 40px 0;\n}\n\n.home-btn {\n  font-size: 1.1rem;\n  padding: 15px 35px;\n}\n\n.loading-container,\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 70vh;\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.spinner {\n  width: 60px;\n  height: 60px;\n  border: 5px solid #e2e8f0;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-container p,\n.error-container p {\n  font-size: 1.2rem;\n  color: #718096;\n  margin: 10px 0;\n}\n\n.error-container h2 {\n  font-size: 2rem;\n  color: #2d3748;\n  margin: 0 0 15px 0;\n}\n\n.no-images {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 15px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.no-images p {\n  font-size: 1.2rem;\n  color: #718096;\n  margin: 0;\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .images-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .images-header h1 {\n    font-size: 2rem;\n  }\n\n  .images-gallery {\n    grid-template-columns: 1fr;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .download-all-btn {\n    width: 100%;\n    padding: 15px;\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
